// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3v6ZY","loaderOuter":"PageOverlayLoader_loaderOuter__1nDiF"};